export const roles = ['agent', 'recruiter', 'trainer', 'admin'];

export const users = {
  agent: {
    id: 'usr-001',
    name: 'Sofía Martínez',
    email: 'sofia.martinez@example.com',
    role: 'agent',
    language: 'es',
    country: 'México',
    avatar: 'SM',
    joinedAt: '2024-03-12'
  },
  recruiter: {
    id: 'usr-002',
    name: 'Carlos Rivera',
    email: 'carlos.rivera@example.com',
    role: 'recruiter',
    language: 'es',
    country: 'Colombia',
    avatar: 'CR',
    joinedAt: '2023-11-08'
  },
  trainer: {
    id: 'usr-003',
    name: 'Elena Torres',
    email: 'elena.torres@example.com',
    role: 'trainer',
    language: 'en',
    country: 'United States',
    avatar: 'ET',
    joinedAt: '2022-07-19'
  },
  admin: {
    id: 'usr-004',
    name: 'Daniel Gómez',
    email: 'daniel.gomez@example.com',
    role: 'admin',
    language: 'en',
    country: 'Panamá',
    avatar: 'DG',
    joinedAt: '2021-09-02'
  }
};

export const videos = [
  { id: 1, title: 'financialFoundations', category: 'coreTraining', duration: '18 min', progress: 72 },
  { id: 2, title: 'clientDiscovery', category: 'salesSkills', duration: '24 min', progress: 45 },
  { id: 3, title: 'complianceEssentials', category: 'compliance', duration: '14 min', progress: 20 }
];

export const resources = [
  { id: 1, title: 'clientMeetingGuide', type: 'pdfGuide', date: 'twoDaysAgo' },
  { id: 2, title: 'protectionPlanning', type: 'presentation', date: 'threeDaysAgo' },
  { id: 3, title: 'weeklyMarketBrief', type: 'marketUpdate', date: 'fiveDaysAgo' }
];

export const translations = {
  en: {
    appName: 'GFI International Trainer Hub',
    tagline: 'One trusted place to learn, grow, and serve with confidence.',
    chooseRole: 'Choose your demo role',
    roleHelper: 'Preview the platform from any team perspective.',
    continueDemo: 'Continue as demo user',
    language: 'Language',
    english: 'EN',
    spanish: 'ES',
    agent: 'Agent',
    recruiter: 'Recruiter',
    trainer: 'Trainer',
    admin: 'Admin',
    agentDescription: 'Access training, resources, and onboarding.',
    recruiterDescription: 'Support agents and manage invitations.',
    trainerDescription: 'Publish and organize training content.',
    adminDescription: 'Oversee users, content, and platform settings.',
    home: 'Home',
    training: 'Training',
    resources: 'Resources',
    onboarding: 'Onboarding',
    profile: 'Profile',
    invitations: 'Invitations',
    upload: 'Upload',
    myContent: 'My Content',
    users: 'Users',
    settings: 'Settings',
    welcome: 'Welcome back',
    welcomeAgent: 'Continue building the knowledge you need to serve clients confidently.',
    welcomeRecruiter: 'Keep your agents moving forward and follow up on pending invitations.',
    welcomeTrainer: 'Your latest learning resources are ready to review and share.',
    welcomeAdmin: 'Here is a quick view of learning activity across the organization.',
    continueWatching: 'Continue watching',
    newThisWeek: 'New this week',
    viewAll: 'View all',
    resume: 'Resume',
    pendingInvitations: 'Pending invitations',
    invitationsNeedAttention: 'Invitations awaiting a response',
    reviewInvitations: 'Review invitations',
    financialFoundations: 'Financial Foundations',
    clientDiscovery: 'Effective Client Discovery',
    complianceEssentials: 'Compliance Essentials',
    coreTraining: 'Core training',
    salesSkills: 'Sales skills',
    compliance: 'Compliance',
    clientMeetingGuide: 'Client Meeting Guide',
    protectionPlanning: 'Protection Planning Deck',
    weeklyMarketBrief: 'Weekly Market Brief',
    pdfGuide: 'PDF guide',
    presentation: 'Presentation',
    marketUpdate: 'Market update',
    twoDaysAgo: '2 days ago',
    threeDaysAgo: '3 days ago',
    fiveDaysAgo: '5 days ago',
    switchDemoRole: 'Switch demo role',
    signedInAs: 'Demo user',
    accountMenu: 'Open account menu',
    closeMenu: 'Close menu',
    preferredLanguage: 'Preferred language',
    country: 'Country',
    email: 'Email',
    memberSince: 'Member since',
    signOut: 'Sign out',
    profileDetails: 'Profile details',
    role: 'Role',
    progress: 'progress',
    emptyTitle: 'Nothing here yet',
    emptyMessage: 'New content will appear here when it is available.',
    mobileNavigation: 'Main navigation',
    selectRole: 'Select role',
    menu: 'Menu',
    demoNotice: 'Interactive demo · Local sample data',
    joinedDate: 'Joined',
    pageDescriptions: {
      training: 'Browse learning paths and build your expertise.',
      resources: 'Find trusted guides, presentations, and tools.',
      onboarding: 'Follow your onboarding steps in one place.',
      invitations: 'Track and manage invitations to new agents.',
      upload: 'Add new training materials for your teams.',
      myContent: 'Review the resources you have published.',
      users: 'Manage people and role access.',
      settings: 'Configure your organization preferences.'
    }
  },
  es: {
    appName: 'Centro de Capacitación GFI International',
    tagline: 'Un solo lugar confiable para aprender, crecer y servir con seguridad.',
    chooseRole: 'Elige tu rol de demostración',
    roleHelper: 'Explora la plataforma desde cualquier perspectiva del equipo.',
    continueDemo: 'Continuar como usuario demo',
    language: 'Idioma',
    english: 'EN',
    spanish: 'ES',
    agent: 'Agente',
    recruiter: 'Reclutador',
    trainer: 'Capacitador',
    admin: 'Administrador',
    agentDescription: 'Accede a capacitación, recursos e incorporación.',
    recruiterDescription: 'Apoya a agentes y administra invitaciones.',
    trainerDescription: 'Publica y organiza contenido de capacitación.',
    adminDescription: 'Supervisa usuarios, contenido y configuración.',
    home: 'Inicio',
    training: 'Capacitación',
    resources: 'Recursos',
    onboarding: 'Incorporación',
    profile: 'Perfil',
    invitations: 'Invitaciones',
    upload: 'Subir',
    myContent: 'Mi contenido',
    users: 'Usuarios',
    settings: 'Configuración',
    welcome: 'Te damos la bienvenida',
    welcomeAgent: 'Continúa desarrollando el conocimiento para atender a tus clientes con seguridad.',
    welcomeRecruiter: 'Ayuda a tus agentes a avanzar y revisa las invitaciones pendientes.',
    welcomeTrainer: 'Tus recursos de aprendizaje más recientes están listos para revisar y compartir.',
    welcomeAdmin: 'Aquí tienes una vista rápida de la actividad de aprendizaje de la organización.',
    continueWatching: 'Continuar viendo',
    newThisWeek: 'Nuevo esta semana',
    viewAll: 'Ver todo',
    resume: 'Continuar',
    pendingInvitations: 'Invitaciones pendientes',
    invitationsNeedAttention: 'Invitaciones en espera de respuesta',
    reviewInvitations: 'Revisar invitaciones',
    financialFoundations: 'Fundamentos Financieros',
    clientDiscovery: 'Descubrimiento Efectivo del Cliente',
    complianceEssentials: 'Fundamentos de Cumplimiento',
    coreTraining: 'Capacitación esencial',
    salesSkills: 'Habilidades de venta',
    compliance: 'Cumplimiento',
    clientMeetingGuide: 'Guía para Reuniones con Clientes',
    protectionPlanning: 'Presentación de Planificación de Protección',
    weeklyMarketBrief: 'Resumen Semanal del Mercado',
    pdfGuide: 'Guía PDF',
    presentation: 'Presentación',
    marketUpdate: 'Actualización del mercado',
    twoDaysAgo: 'Hace 2 días',
    threeDaysAgo: 'Hace 3 días',
    fiveDaysAgo: 'Hace 5 días',
    switchDemoRole: 'Cambiar rol de demostración',
    signedInAs: 'Usuario demo',
    accountMenu: 'Abrir menú de cuenta',
    closeMenu: 'Cerrar menú',
    preferredLanguage: 'Idioma preferido',
    country: 'País',
    email: 'Correo electrónico',
    memberSince: 'Miembro desde',
    signOut: 'Cerrar sesión',
    profileDetails: 'Detalles del perfil',
    role: 'Rol',
    progress: 'completado',
    emptyTitle: 'Aún no hay contenido',
    emptyMessage: 'El contenido nuevo aparecerá aquí cuando esté disponible.',
    mobileNavigation: 'Navegación principal',
    selectRole: 'Seleccionar rol',
    menu: 'Menú',
    demoNotice: 'Demo interactiva · Datos de muestra locales',
    joinedDate: 'Se unió',
    pageDescriptions: {
      training: 'Explora rutas de aprendizaje y desarrolla tu experiencia.',
      resources: 'Encuentra guías, presentaciones y herramientas confiables.',
      onboarding: 'Sigue tus pasos de incorporación en un solo lugar.',
      invitations: 'Revisa y administra invitaciones para nuevos agentes.',
      upload: 'Agrega nuevos materiales de capacitación para tus equipos.',
      myContent: 'Revisa los recursos que has publicado.',
      users: 'Administra personas y accesos por rol.',
      settings: 'Configura las preferencias de tu organización.'
    }
  }
};

export const navByRole = {
  agent: ['home', 'training', 'resources', 'onboarding', 'profile'],
  recruiter: ['home', 'training', 'resources', 'onboarding', 'invitations', 'profile'],
  trainer: ['home', 'training', 'resources', 'onboarding', 'upload', 'myContent', 'profile'],
  admin: [
    'home',
    'training',
    'resources',
    'onboarding',
    'invitations',
    'upload',
    'myContent',
    'users',
    'settings',
    'profile'
  ]
};